import { callAPI } from "../../config/AxiosTemplate"
import { API } from "../../constants/APIConstants"

export const getWhatsappLoanRequestListAction = (reqObj, callback) => {
    callAPI(
        "getWhatsappLoanRequestList",
        API.getWhatsappLoanRequestList,
        "GET",
        reqObj,
        (apiResponse) => {
            callback(apiResponse);
        }
    );
};

export const updateWhatsappLoanRequestAction = (reqObj, callback) => {
    callAPI(
        "updateWhatsappLoanRequest",
        API.updateWhatsappLoanRequest,
        "PATCH",
        reqObj,
        (apiResponse) => {
            callback(apiResponse);
        }
    );
};

export const getFilteredMinimartsWithWhatsAppDetails = (reqObj, callback) => {
    callAPI(
        "getFilteredMinimartsWithWhatsAppDetails",
        API.getFilteredMinimartsWithWhatsAppDetails,
        "POST",
        reqObj,
        (apiResponse) => {
            callback(apiResponse);
        }
    );
}

export const sendBusinessInitiatedWhatsAppMessage = (reqObj, callback) => {
    callAPI(
        "sendBusinessInitiatedWhatsAppMessage",
        API.sendBusinessInitiatedWhatsAppMessage,
        "POST",
        reqObj,
        (apiResponse) => {
            callback(apiResponse);
        }
    );
}

export const downloadWhatsappInterestsReportAction = (requestString, callback) => {
    callAPI(
        "downloadWhatsappInterestsReport",
        API.downloadWhatsappInterestsReport.concat(requestString),
        "POST",
        {},
        (apiResponse) => {
            callback(apiResponse);
        },
        true
    );
}